'use strict';

var helper = require('../helper');

module.exports = {
    pushNewProduct (data) {
        const product = data.data.product;
        const helperData = $('.analytics.helperData').data();
        const currencyCode = helperData.currency;
        const brand = helperData.brand;
        let promoString = '';
        if (!product.promotions || product.promotions.length === 0) {
            promoString = 'no_promotion';
        } else {
            promoString = product.promotions.map((e) => e.id).join('_');
        }

        const productGenderMap = {
            1: 'Woman',
            2: 'Man',
            3: 'Girl',
            4: 'Boy',
            5: 'Unisex',
            6: 'Baby'
        };
        function getProductGender (product) {
            if (product.sapCategoryCode) {
                let categoryCode = product.sapCategoryCode;
                return productGenderMap[parseInt(categoryCode[categoryCode.length - 1])];
            }
            return '';
        }

        let isOnSale = false;
        for (var i = 0; i < product.variationAttributes[0].values.length; i++) {
            var variationValue = product.variationAttributes[0].values[i];
            if (variationValue.isOnSale) {
                isOnSale = true;
                break;
            }
        }
        let category = product.categoryPath || $('.analytics.product').data('item_category');
        if (category) {
            category = category.replace(/-/g, '_'); // this should be done server side
        }
        if (data.type === 'color') {
            const baseInfo = helper.getProductBaseInfo(product);
            const productSustainability = helper.getProductSustainability(product);
            const GTMData = helper.getGtmData();

            const itemListName = data.itemListName || GTMData.item_list_name;
            const itemListId = data.itemListId || GTMData.item_list_id;

            let pushObject = {
                'event': 'view_item',
                'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                'ecommerce': {
                    'currency': currencyCode,
                    'item_list_name': itemListName,
                    'item_list_id': itemListId,
                    'items': [{
                        'item_name': product.nameEng,
                        'item_id': baseInfo.id,
                        'price': product.price.sales.value,
                        'quantity': product.selectedQuantity,
                        'item_list_name': itemListName,
                        'item_list_id': itemListId,
                        'item_brand': brand,
                        'item_category': category,
                        'item_variant': baseInfo.color,
                        'index': GTMData.index,
                        'size': baseInfo.size,
                        'item_on_sale': product.price.list ? 'Yes' : 'No',
                        'item_availability': 'available',
                        'coupon': promoString,
                        'item_color': product.colorFamilyEng || '',
                        'item_sfcc': product.id,
                        'item_category2': getProductGender(product),
                        'item_category3': product.secondLevelCategory,
                        'item_category4': product.thirdLevelCategory,
                        'item_category5': product.fourthLevelCategory,
                        'item_sustainable': productSustainability,
                        'discount': isOnSale && product.price.list ? (product.price.list.value - product.price.sales.value).toFixed(2) : 0.00
                    }]
                }
            };
            pushObject.ecommerce.items[0] = helper.formatProductForAnalytics(pushObject.ecommerce.items[0]);
            helper.push({ecommerce: null});
            helper.push(pushObject);
        }
    },

    pushProductChangeColorInteraction (color, sku) {
        sku = helper.getFormatSku(sku);
        this.pushProductChangeColor(color, sku);
    },

    pushProductChangeColor (color, sku, type) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '27',
            'eventname': 'product',
            'action': 'change_color',
            'text': color,
            'product_id': sku,
            'type': type
        };

        helper.log('Pushing product change color interaction!', true);
        helper.push(pushObject);
    },

    getFormattedSkuForAnalytics (size, sku) {
        let splitSku = sku.split('_');
        let selectedPid = splitSku[0];
        let selectedColor = splitSku[1];
        let formattedSku = selectedPid + '_' + selectedColor + '_' + size;
        return formattedSku;
    },

    pushProductChangeSizeInteraction (size, sku) {
        if (!size) {
            return;
        }
        sku = helper.getFormatSku(sku);
        sku = this.getFormattedSkuForAnalytics(size, sku);

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '28',
            'eventname': 'product',
            'action': 'change_size',
            'text': size,
            'product_id': sku
        };

        helper.log('Pushing product change size interaction!', true);
        helper.push(pushObject);
    },

    pushProductZoomInteraction (sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '29',
            'eventname': 'product',
            'action': 'zoom',
            'product_id': sku
        };

        helper.log('Pushing product change size interaction!', true);
        helper.push(pushObject);
    },

    pushcalculateSizeInteraction () {
        let sku = $('.product-detail-keeper').data('pid').replace(/%20/g, ' ');
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '49',
            'eventname': 'product',
            'action': 'calculate_size',
            'product_id': sku
        };
        helper.push(pushObject);
    },

    pushProductInformationalMenuChange (info) {
        if (!info) {
            return;
        }
        info = helper.formatString(info);

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '30',
            'eventname': 'product',
            'action': 'expand',
            'type': info
        };

        helper.log('Pushing product toggle informational content: ' + info + '!', true);
        helper.push(pushObject);
    },

    pushProductImageClickInteraction (photoType, sku) {
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '46',
            'eventname': 'product',
            'action': 'image_swipe',
            'type': photoType,
            'product_id': sku
        };

        helper.log('Pushing product click on product image interaction!', true);
        helper.push(pushObject);
    },

    pushFindYourSizeClickInteraction (sku) {
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '49',
            'eventname': 'product',
            'action': 'calculate_size',
            'product_id': sku
        };

        helper.log('Pushing find your size on product interaction!', true);
        helper.push(pushObject);
    },

    pushFindInStoreSoldoutInteraction (sku) {
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '93',
            'eventname': 'product',
            'action': 'find_in_store',
            'product_id': sku
        };

        helper.log('Pushing find in store for soldout products interaction!', true);
        helper.push(pushObject);
    },

    pushProductCheckAvailabilitySizeClickInteraction (sku, size, name, isNotAvailable) {
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': isNotAvailable ? '96' : '95',
            'eventname': 'product',
            'action': 'check_availability',
            'type': isNotAvailable ? 'no_online_availability' : 'online_availability',
            'text': size,
            'product_id': sku + '_' + size
        };

        helper.log('Pushing check availability after size selection interaction!', true);
        helper.push(pushObject);
    },

    pushRatingAndReviewsInteraction105 (action, word, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '105',
            'eventCategory': 'product_rating_and_reviews',
            'eventAction': action,
            'eventLabel': word,
            'dimension64': sku
        };

        helper.log('Pushing rating and reviews interaction - pdp - filter or sort products', true);
        helper.push(pushObject);
    },

    pushRatingAndReviewsInteraction106 (productName, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '100',
            'eventname': 'product_rating_and_reviews',
            'action': 'review_guidelines',
            'product_id': sku
        };

        helper.log('Pushing rating and reviews interaction - form - guidelines', true);
        helper.push(pushObject);
    },

    pushRatingAndReviewsInteraction101 (overallRating, sizeRating, qualityRating, comfortabilityRating, sku) {
        if (overallRating === 1) {
            overallRating = '1_star';
        } else if (overallRating === 2) {
            overallRating = '2_stars';
        } else if (overallRating === 3) {
            overallRating = '3_stars';
        } else if (overallRating === 4) {
            overallRating = '4_stars';
        } else if (overallRating === 5) {
            overallRating = '5_stars';
        }
        if (!sizeRating) {
            sizeRating = 'feedback_not_provided';
        }
        if (!qualityRating) {
            qualityRating = 'feedback_not_provided';
        }
        if (!comfortabilityRating) {
            comfortabilityRating = 'feedback_not_provided';
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '101',
            'eventname': 'product_reviewed',
            'action': 'submit_the_form',
            'label': overallRating,
            'size_rating': sizeRating,
            'price_rating': qualityRating,
            'comfortability_rating': comfortabilityRating,
            'product_id': sku
        };

        helper.log('Pushing rating and reviews interaction - form - submit', true);
        helper.push(pushObject);
    },

    pushRatingAndReviewsInteraction108 (action) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '108',
            'eventname': 'product_rating_and_reviews',
            'action': action
        };

        helper.log('Pushing rating and reviews interaction - review sent', true);
        helper.push(pushObject);
    },

    pushReviewsButtonOnPdpInteraction (category, sku) {
        if (!category || !sku) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '142',
            'eventname': 'product_rating_and_reviews',
            'action': 'see_the_reviews',
            'type': category,
            'product_id': sku
        };

        helper.log('Pushing see the reviews button interaction in pdp!', true);
        helper.push(pushObject);
    },

    pushLikeDislikeToReview (action, stars, sku) {
        if (!action || !stars || !sku) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '143',
            'eventname': 'product_rating_and_reviews',
            'action': action,
            'type': stars,
            'product_id': sku
        };

        helper.log('Pushing like or dislike button to a review interaction!', true);
        helper.push(pushObject);
    },

    pushGuidesClickInteraction (type, where, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '145',
            'eventname': 'guide',
            'type': type,
            'position': where,
            'product_id': sku
        };

        helper.log('Pushing product click on style and guides interaction!', true);
        helper.push(pushObject);
    },

    // 6.131 CUSTOMIZE PRODUCT
    pushCustomizeProductInteraction (name, sku) {
        if (!name || !sku) {
            return;
        }
        helper.log('Pushing customize product click interaction!', true);
        helper.push({
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '152',
            'eventname': 'product',
            'action': 'customize',
            'product_id': sku
        });
    },

    // 6.132 CUSTOMIZE PRODUCT - ACTIONS
    pushCustomizeProductActionsInteraction (action, sku) {
        if (!action || !sku) {
            return;
        }
        helper.log('Pushing customize product click interaction!', true);
        helper.push({
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '153',
            'eventname': 'product',
            'action': 'customize_action',
            'type': action,
            'product_id': sku
        });
    },

    pushFindOutMoreTraceabilityInteraction () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '167',
            'eventname': 'traceability_more_info'
        };

        helper.log('Pushing find out more traceability interaction!', true);
        helper.push(pushObject);
    },

    pushProductDetailPageMatchWithCTAs (label, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '187',
            'eventname': 'product',
            'action': 'match_with_cta', 
            'label': label,
            'product_id': sku
        };

        helper.log('Pushing style with or complete the promo interaction!', true);
        helper.push(pushObject);
    },

};
